export default __webpack_public_path__ + "static/media/img2.071f2689.jpg";